import { Box, List, ListItem, TablePagination, Typography, CircularProgress } from '@material-ui/core';
import React, { Fragment, useState } from 'react';
import { ILink } from '../../../../services/types';
import useStyles from './styles';

interface IProps {
  links: ILink[] | undefined;
  totalCount: number;
  onRequestFetch: (page: number, rowsPerPage: number) => void;
  onSelectLink: (link: ILink) => void;
}

const LinkList = (props: IProps): JSX.Element => {
  const classes = useStyles();

  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(0);

  return (
    <Box>
      <Box className={classes.linkListWrap}>
        {!props.links && (
          <Box padding={2} textAlign="center">
            <CircularProgress size={30} />
          </Box>
        )}
        {props.links && (
          <Fragment>
            <List>
              {props.links &&
                props.links.map(link => (
                  <ListItem
                    button
                    key={link.id}
                    classes={{
                      gutters: classes.linkListItem,
                    }}
                    onClick={() => {
                      if (link) {
                        props.onSelectLink(link);
                      }
                    }}
                  >
                    <img src={`${process.env.CDN_URL}/${link.coverUrl}?w=90` || ''} className={classes.linkCoverImage} />
                    <Box>
                      <Typography className={classes.linkListTitle}>{link.title}</Typography>
                      <Typography className={classes.linkListUrl}>
                        <a href={link.url} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>
                          {link.url}
                        </a>
                      </Typography>
                      {link.label && <Typography className={classes.linkListLabel}>{link.label}</Typography>}
                      {link.desc && <Typography className={classes.linkListDesc}>{link.desc}</Typography>}
                      <Typography className={classes.linkType}>{`${link.type.toUpperCase()} / ${link.id}`}</Typography>
                    </Box>
                  </ListItem>
                ))}
            </List>
            <TablePagination
              count={props.totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={(e: unknown, v: number) => {
                props.onRequestFetch(v, rowsPerPage);
                setPage(v);
              }}
              onChangeRowsPerPage={(event: React.ChangeEvent<HTMLInputElement>) => {
                const rpp = parseInt(event.target.value, 10);
                setRowsPerPage(rpp);
                props.onRequestFetch(0, rpp);
                setPage(0);
              }}
            />
          </Fragment>
        )}
      </Box>
    </Box>
  );
};

export default LinkList;
